var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("topbar", { attrs: { text: "测试结果" } }),
      _vm._v(" "),
      _c("div", { staticClass: "testBox" }, [
        _c("div", { staticClass: "iconBg" }, [
          _c("img", {
            staticClass: "aircraft",
            class: { active: _vm.status },
            attrs: { src: require("assets/aircraft.png"), alt: "" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "iconBg2" }, [
            _c("img", {
              staticClass: "sendSuccess",
              class: { active: _vm.status },
              attrs: { src: require("assets/sendSuccess.png"), alt: "" }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "word" }, [_vm._v("提交成功")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn",
            on: {
              click: function($event) {
                _vm.to(
                  "mentalExperience?comboId=" +
                    _vm.comboId +
                    "&groupId=" +
                    _vm.groupId
                )
              }
            }
          },
          [_vm._v("返回心理体检")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7805c42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7805c42","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/testResult.vue
// module id = null
// module chunks = 